import { Label } from './types';

const GREEN_COLOR = '#008A27';

export const getLabelColor = (label: Label) => {
  if (
    label.type === 'LABEL_TYPE_SWAN' ||
    (label.type === 'LABEL_TYPE_SUSTAINABILITY' && !label.color)
  ) {
    return GREEN_COLOR;
  }

  if (label.color) {
    return label.color;
  }

  return '';
};
